import { render } from "./LiveChannelRow.vue?vue&type=template&id=3072f0a4"
import script from "./LiveChannelRow.vue?vue&type=script&lang=js"
export * from "./LiveChannelRow.vue?vue&type=script&lang=js"

import "../assets/style.css?vue&type=style&index=0&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__